import { isRouteErrorResponse, useRouteError } from "@remix-run/react";

import ErrorPage from "~/components/error";

export function ErrorBoundaryComponent() {
  const error = useRouteError();

  let status = 500;
  let statusText = "Internal Server Error";
  let message = "An unexpected error occurred. Please try again later.";
  let stack;

  if (isRouteErrorResponse(error)) {
    status = error.status;
    statusText = error.statusText;
    message = error.data?.message || "Something went wrong.";
  } else if (error instanceof Error) {
    message = error.message;
    stack = error.stack;
  } else if (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    typeof error.status === "number" &&
    error.status === 401
  ) {
    console.error("Unauthorized request");
    window.location.reload();
    return null;
  }

  return <ErrorPage status={status} statusText={statusText} message={message} stack={stack} />;
}
